// Dev-only logger. Silently no-ops in production so we don't leak debug info
// or incur console overhead on prod bundles. Use everywhere instead of raw console.error.
const IS_DEV = process.env.NODE_ENV !== "production";

export const logger = {
  error: (...args) => { if (IS_DEV) console.error(...args); },
  warn: (...args) => { if (IS_DEV) console.warn(...args); },
  info: (...args) => { if (IS_DEV) console.info(...args); },
  debug: (...args) => { if (IS_DEV) console.debug(...args); },
};
